import React from 'react';

const BlitzCoinIcon = () => { 
	return (
		<svg width='88' height='88' viewBox='0 0 88 88' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='88' height='88' rx='44' fill='none' />
			<g style={{ mixBlendMode: 'multiply' }}>
				<path d='M19 60V28L32.3373 41.0612V60H19Z' fill='#262524' />
				<path
					d='M34.7895 60V38L44.6579 28.6667L58.9949 43.6735V38.449L69 29.0143V60H60.9942L45.6661 44.3265V60H34.7895Z'
					fill='#262524'
				/>
			</g>
		</svg>
	);
};

export default BlitzCoinIcon;
